import { ForgeProjectSection } from "./SDKForgeProjectSection";
export class ForgeProjectFeatureSection extends ForgeProjectSection {
    constructor(model) {
        super(model);
        this.childType = "Feature";
    }
}
